import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getUserByEmail, updateUserProfile } from '../commonApi';

function UpdateUserProfile() {
  const { control, handleSubmit, setValue } = useForm();
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});

  // Function to fetch user by email
  const fetchUserDetails = async (email) => {
    try {
      const userData = await getUserByEmail(email);
      if (userData) {
        setUserData(userData);
        setValue('firstName', userData.firstName);
        setValue('lastName', userData.lastName);
        setValue('email', userData.email);
        setValue('phone', userData.phone);
      } else {
        // If no user is found, set default empty values
        setValue('firstName', '');
        setValue('lastName', '');
        setValue('email', '');
        setValue('phone', '');
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  // Function to update user profile
  const saveUserProfile = async (userId, profileData) => {
    try {
      await updateUserProfile(userId, profileData);
      toast.success('User profile updated successfully');
      navigate('/users');
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error('Failed to update user profile');
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const accessToken = localStorage.getItem('accessToken');
        if (!accessToken) {
          console.error('No access token available');
          return;
        }

        const tokenParsed = JSON.parse(atob(accessToken.split('.')[1])); // Decode token payload
        const userEmail = tokenParsed?.email || null;
        if (!userEmail) {
          console.error('No user email found in token');
          return;
        }

        await fetchUserDetails(userEmail); // Fetch user by email
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    fetchUserData();
  }, [setValue]);

  const onSubmit = async (data) => {
    const updatedData = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone,
    };
    await saveUserProfile(userData.id, updatedData);
  };

  const handleCancel = () => {
    navigate('/users');
  };

  return (
    <div className='custom_form_wrapper'>
      <div className='custom_form_header'>
        <p className='form_head_title'>Update User Profile</p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className='custom_form_body_wrapper h-100vh-166px'>
          <div className='row'>
            <div className='col-md-4 col-xxl-3 col-6 mb-4'>
              <label htmlFor='firstName' className='form-label'>First Name</label>
              <Controller
                control={control}
                name='firstName'
                defaultValue=''
                render={({ field }) => (
                  <input type='text' id='firstName' className='form-control' {...field} />
                )}
              />
            </div>

            <div className='col-md-4 col-xxl-3 col-6 mb-4'>
              <label htmlFor='lastName' className='form-label'>Last Name</label>
              <Controller
                control={control}
                name='lastName'
                defaultValue=''
                render={({ field }) => (
                  <input type='text' id='lastName' className='form-control' {...field} />
                )}
              />
            </div>

            <div className='col-md-4 col-xxl-3 col-6 mb-4'>
              <label htmlFor='email' className='form-label'>Email</label>
              <Controller
                control={control}
                name='email'
                defaultValue=''
                render={({ field }) => (
                  <input type='text' id='email' className='form-control' {...field} disabled />
                )}
              />
            </div>
            <div className='col-md-4 col-xxl-3 col-6 mb-4'>
              <label htmlFor='phone' className='form-label'>Phone</label>
              <Controller
                control={control}
                name='phone'
                defaultValue=''
                render={({ field }) => (
                  <input type='text' id='phone' className='form-control' {...field} disabled />
                )}
              />
            </div>
          </div>
          <div className='custom_form_footer_wrapper'>
            <div className='d-flex align-items-center justify-content-end'>
              <button type='submit' className='btn primary_btn btn-loader'>
                Save Changes
              </button>
              <button type='button' className='btn light_primary_btn me-3' onClick={handleCancel}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default UpdateUserProfile;
